import { Component, OnInit, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';
import { UserService } from '@app/core/services/user/user.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'howden-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  imports: [MatButton]
})
export class ForbiddenComponent implements OnInit {
  private readonly usrSrv = inject(UserService);
  private readonly router = inject(Router);
  private authService = inject(MsalService);

  account?: string = '';

  ngOnInit(): void {
    this.account = this.authService.instance.getActiveAccount()?.username;
    this.authService.instance.setActiveAccount(null);
  }

  retry() {
    this.usrSrv.clearIDData();
    const callBack = this.usrSrv.appData.callback ? `?callback=${this.usrSrv.appData.callback}` : '';
    if (this.usrSrv.appData.isInternal) {
      this.router.navigateByUrl(`login-dir${callBack}`);
    } else {
      this.router.navigateByUrl(`external-login${callBack}`);
    }
  }
}
